export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13217.e79ac58b.jpg";